<template>
<div>
    <b-nav :class="{'helper-nav': true, 'helper-fixed': helperNavFixed}" vertical v-b-scrollspy>
        <slot></slot>
    </b-nav>
</div>
</template>

<script>
export default {

    data: function() {
        return {
            helperNavFixed: false,
        }
    },

    methods: {

        // As of right now this needs to be on the parent
        // scrollIntoView (evt) {
        //     evt.preventDefault()
        //     const href = evt.target.getAttribute('href')
        //     const el = href ? document.querySelector(href) : null

        //     if (el)
        //     {
        //         window.scrollTo(0,el.offsetTop+160)
        //     }
        // },

        updateScroll: function(){
            //Get the height
            this.helperNavFixed = (window.pageYOffset >= 150 ? true : false);
        }

    },

    mounted() {
        //Listener for the menu helper
        window.addEventListener('scroll', this.updateScroll);
    },

    destroy() {
        //Remove it
        window.removeEventListener('scroll', this.updateScroll)
    }
}
</script>

<style>
    .helper-nav.helper-fixed {
        position: fixed;
        top: 5px;
    }

    .helper-nav li a {
        padding: 2px 2px;
    }

    .helper-nav li.active a {
        color: #f00;
    }
</style>
